import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import axiosAuth from "../../../axiosAuth";

export interface CrmResourceManagementPayload {
  schoolId?: string;
  crmOpsStatus?: "Green" | "Yellow" | "Red";
  comment?: string;
  regionHeadId?: string;
  relationshipManagerId?: string;
}

export interface CrmResourceManagementResponse {
  data: {
    id: string;
    schoolId: string;
    crmOpsStatus: string;
    comment: string;
    regionHeadId: string;
    relationshipManagerId: string;
    createdAt: string;
    updatedAt: string;
  };
}

const createCrmResourceManagement = async (data: CrmResourceManagementPayload) => {
  const response = await axiosAuth.post<CrmResourceManagementResponse>(
    "/v1/school/crm/resource-management/",
    data
  );
  return response.data;
};

export const useCrmResourceManagementMutation = (
  options?: {
    onSuccess?: (data: CrmResourceManagementResponse) => void;
    onError?: (error: any) => void;
  }
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createCrmResourceManagement,
    onSuccess: (data) => {
      toast.success("Resource management created successfully");
      // Invalidate relevant queries
      queryClient.invalidateQueries({ queryKey: ["schools"] });
      queryClient.invalidateQueries({ queryKey: ["crm-resource-management"] });
      options?.onSuccess?.(data);
    },
    onError: (error: any) => {
      const errorMessage = 
        error?.response?.data?.message || 
        error?.response?.data?.issues?.message || 
        "Failed to create resource management";
      toast.error(errorMessage);
      options?.onError?.(error);
    },
  });
};
